__turbopack_context__.v({
  "button": "n07Ufa_button",
  "clip": "n07Ufa_clip",
  "container": "n07Ufa_container",
  "content": "n07Ufa_content",
  "icon": "n07Ufa_icon",
  "iconLocked": "n07Ufa_iconLocked",
  "iconUnlocked": "n07Ufa_iconUnlocked",
  "inner": "n07Ufa_inner",
  "outer": "n07Ufa_outer",
  "position--left": "n07Ufa_position--left",
  "position--right": "n07Ufa_position--right",
  "sidebar--clipboard": "n07Ufa_sidebar--clipboard",
  "sidebar--filters": "n07Ufa_sidebar--filters",
  "status--expanded": "n07Ufa_status--expanded",
  "status--hovered": "n07Ufa_status--hovered",
});
